import { Button } from "./button";
import { MinimalLoading } from "./minimal-loading";
import { getHomeFallbackPath } from "@/utils/whiteLabelStore";

interface AppLoadingProps {
  error?: boolean;
  onRetry?: () => void;
  timeout?: boolean;
}

export function AppLoading({ error = false, onRetry, timeout = false }: AppLoadingProps) {
  if (error || timeout) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-background">
        <div className="text-center space-y-4 max-w-md mx-auto p-6">
          <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-red-50 text-red-500">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          </div>
          <h2 className="text-2xl font-bold text-foreground">
            {timeout ? "Tempo limite excedido" : "Erro na inicialização"}
          </h2>
          <p className="text-muted-foreground">
            {timeout 
              ? "A aplicação está demorando mais que o esperado para carregar."
              : "Ocorreu um erro ao inicializar a aplicação."
            }
          </p>
          <div className="space-y-2">
            <Button 
              onClick={onRetry || (() => window.location.reload())}
              className="w-full"
            >
              Tentar novamente
            </Button>
            <Button 
              variant="outline" 
              onClick={() => window.location.href = getHomeFallbackPath()}
              className="w-full"
            >
              Ir para página inicial
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return <MinimalLoading fullScreen size="lg" message="Carregando..." />;
}